import apiClient from 'api/config/apiClient'

export default {
  getCodeCBO(payload) {
    return apiClient.request('cbo', payload)
  },
}
